import { WsSelectCheckBox, WsSelectCheckBoxOptions } from 'wisestep-base';

import useGetBusinessDefination from '../../../features/submissionsNew/components/hooks/useGetBusinessDefination';

interface BusinessDefinationFilterProps {
  name: string;
  disabled?: boolean;
  placeholder?: string;
}

const BusinessDefinationFilter = ({
  name,
  disabled = false,
  placeholder = '',
}: BusinessDefinationFilterProps) => {
  const { businessDefinations } = useGetBusinessDefination();

  const businessDefinationOptions: WsSelectCheckBoxOptions[] = businessDefinations.map(
    (defination) => ({
      label: defination.businessDefinitionName,
      value: defination.id,
    })
  );

  return (
    <WsSelectCheckBox
      name={name}
      disabled={disabled}
      placeholder={placeholder}
      options={businessDefinationOptions}
      fullWidth
      size="small"
    />
  );
};

export default BusinessDefinationFilter;
